// extracted by mini-css-extract-plugin
export default {"container":"ToggleBox_container__5REJ2","arrow":"ToggleBox_arrow__ONcyH","arrowDown":"ToggleBox_arrowDown__-DyMf","arrowUp":"ToggleBox_arrowUp__3V+45"};